// TODO: delete this once we no longer use Razor templates
import { NextJSProcess } from '@gik/core/types/process';

// process.browser is only declared in NextJS
// is there a better way we can do this by using aliasing? (Same as links)
declare const process: NextJSProcess;

const deleteDotNetLoadingSpinner = () => {
  // if (!process.browser) return;
  const loadingSpinner = document.getElementById('dotnet-react-loading-spinner');
  if (loadingSpinner) {
    loadingSpinner.parentElement.removeChild(loadingSpinner);
  }
};

export { deleteDotNetLoadingSpinner };
